import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { ComplaintDetail } from '@/features/ndis-standards/complaints/detail'

const searchSchema = z.object({
  from: z.string().optional(),
  obligation: z.string().optional(),
})

export const Route = createFileRoute(
  '/_authenticated/_organization/compliance/complaints/$complaintId'
)({
  validateSearch: searchSchema,
  component: ComplaintDetail,
})
